import React from 'react';

import type { SanityCheck } from '../types';

export function healthStatusDot(status: SanityCheck['status']): string {
  if (status === 'ok') {
    return 'status-dot status-dot--ok';
  }
  if (status === 'warning') {
    return 'status-dot status-dot--disabled';
  }
  return 'status-dot status-dot--missing';
}

export default function HealthChecksList({ checks }: { checks: SanityCheck[] }) {
  return (
    <ul className="list">
      {checks.map((check) => (
        <li key={check.id}>
          <span className={healthStatusDot(check.status)} />
          <span>{check.message}</span>
          {check.detail && <span className="mono">{check.detail}</span>}
        </li>
      ))}
    </ul>
  );
}
